import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css'; // Import the CSS file

const Footer = () => {
  const location = useLocation();
  const showButton = location && location.pathname !== '/request-service';

  return (
    <footer className="footer">
      <div className="footer-inner">
        {showButton && (
          <Link to="/request-service" className="book-now-button">Request Service</Link>
        )}
        <div className="footer-text">Prime House Cleaning</div>
      </div>
    </footer>
  );
};

export default Footer;